import SgdfCommentTagPicker from './comment-tag-picker.component.js';
export * from './comment-tag-picker.component.js';
export default SgdfCommentTagPicker;
SgdfCommentTagPicker.define('sgdf-comment-tag-picker');
//# sourceMappingURL=comment-tag-picker.js.map